// src/components/TidioWidget.js
import { useEffect } from "react";

const TidioWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//code.tidio.co/xbvrs6yp1u9d3yum89oizeiu2cponvg2.js"; // Replace this
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return null;
};

export default TidioWidget;



<script src="//code.tidio.co/xbvrs6yp1u9d3yum89oizeiu2cponvg2.js" async></script>